<template>
  <div>
    <a-ext-check-box :disabled="disabled" v-for="opt in options" :label="opt.text" v-model="opt.checked" width="120px" @change="onChange">

    </a-ext-check-box>
  </div>
</template>

<script>
import AExtCheckBox from './AExtCheckBox'
import mixin from '../mixin/AExtStringMixin'
import {searchProjectBadDic as getDic} from '../../../api/api';

export default {
    name: "AExtMonitLinkCheckBox",
    mixins:[mixin],
    components:{AExtCheckBox},
    props:{
        disabled:{
            type:Boolean,
            default:false
        },
        param:{
            type: Object,
            default: ''
        }
    },
    data(){
        return{
            localValue:'',
            options:[]//name,value,check
        }
    },
    created(){
        this.init()
    },
    watch: {
        localValue(val) {
            // this.options=options;
            let checkedList=val.split("、");
            this.options.forEach(item=>{
                if(checkedList.indexOf(item.value)>-1)
                {
                    item.checked=true;
                }
                else {
                    item.checked=false;
                }
            });
        }
    },
    methods:{
        init(){
            getDic(this.param.projectId).then(result => {

                if (result.data && result.data.succ) {
                    const data = [];
                    result.data.data.forEach(r => {
                        data.push({
                            value: r.name,
                            text: r.name,
                        });
                    });
                    this.options = data;
                    // alert(JSON.stringify(this.options))
                    let checkedList=this.localValue.split(",");
                    this.options.forEach(item=>{
                        if(checkedList.indexOf(item.value)>-1)
                        {
                            item.checked=true;
                        }
                        else {
                            item.checked=false;
                        }
                    });
                }
            }).catch(() => {
                this.options = []
            })

        },
        onChange()
        {
            let checkedList=[];
            this.options.forEach(item=>{
               if(item.checked)
               {
                   checkedList.push(item.value)
               }
            });
            this.localValue=checkedList.join('、');
        }
    }
}
</script>

<style scoped>

</style>